module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "ql-pages-container",
    style: ({
      overflow: _vm.inMargin ? 'visible' : 'hidden',
      justifyContent: 'center'
    })
  }, [_c('md-layout', {
    staticClass: "ql-page-layout",
    class: {
      'portrait': !_vm.landscape,
      'md-column': !_vm.landscape
    },
    attrs: {
      "md-row": "",
      "md-gutter": "12"
    }
  }, [_c('div', {
    staticClass: "ql-pages-inner",
    style: (_vm.innerMarginStyle)
  }, [(_vm.pageReady) ? _c('svg', {
    staticClass: "ql-page-graphics",
    style: ({
      height: (_vm.svgTrueHeight + "px"),
      overflow: _vm.inMargin ? 'visible' : 'hidden'
    }),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1"
    }
  }, _vm._l((_vm.positionedCues), function(cue) {
    return _c('line', {
      key: cue.id,
      staticClass: "ql-page-cue-line",
      style: (_vm.cueLineOpacityStyle(cue)),
      attrs: {
        "x1": cue.lineX1,
        "y1": cue.lineY1,
        "x2": cue.lineX2,
        "y2": cue.lineY2,
        "stroke-width": "1",
        "stroke-opacity": _vm.lineOpacity(cue)
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('project-page', {
    staticClass: "md-flex pdf-column pdf-canvas-column",
    style: ({
      order: _vm.pdfPaneOrderByCuePlacement()
    }),
    attrs: {
      "page": _vm.page,
      "cues": _vm.positionedCues,
      "currentCueLayer": _vm.currentCueLayer,
      "locked": true,
      "showMode": _vm.showMode,
      "totalPages": 1,
      "landscape": _vm.landscape
    },
    on: {
      "pageLoaded": _vm.pageLoaded
    }
  }), _vm._v(" "), (_vm.pageReady) ? _c('project-cue-list', {
    staticClass: "pdf-column pdf-cues-column",
    style: (_vm.cuesListStyles()),
    attrs: {
      "cues": _vm.positionedCues,
      "locked": true,
      "openCues": _vm.openCues,
      "totalPages": 1,
      "globalCues": _vm.cues,
      "selectedScale": _vm.selectedScale,
      "cuesListWidth": _vm.cuesListWidth,
      "svgContentWidth": _vm.svgContentWidth,
      "landscape": _vm.landscape
    },
    on: {
      "openCue": _vm.openCue,
      "closeCue": _vm.closeCue
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-break"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-287c39b5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print/print-pages.vue
// module id = 1218
// module chunks = 21